import { faBullhorn, faExclamation, faExclamationTriangle, faInfoCircle, faPen, faStopwatch, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
export const constants = {
  DP_WEEK_START: 1,
  DP_DATE_FORMAT: "DD/MM/YYYY",
  DP_DAYS: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  DP_MONTHS: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],

  DURATIONS: {
    TODAY: "TODAY",
    YESTERDAY: "YESTERDAY",
    _7_DAYS: "7 DAYS",
    _30_DAYS: "30 DAYS",
    THIS_MONTH: "THIS MONTH",
  },

  TAB_BIEN: "TAB_BIEN",
  TAB_ASSOCIATION: "TAB_ASSOCIATION",
  TAB_CLIENT: "TAB_CLIENT",
  TAB_ENCAISSEMENT: "TAB_ENCAISSEMENT",
  TAB_LIBRARY: "TAB_LIBRARY",

  TAB_OBJECTIF: "TAB_OBJECTIF",
  TAB_BULLETIN: "TAB_BULLETIN",

  VALIDATE_PREVIEW: "PREVIEW",
  VALIDATE_CHECK: "CHECK",
  VALIDATE_CONFIRM: "CONFIRM",
  VALIDATE_CONFIRM_AND_PRINT: "CONFIRM_AND_PRINT",

  RECTO: "RECTO",
  VERSO: "VERSO",

  CONSULTATION_SELECT_N_DOSSIER: "N_DOSSIER",
  CONSULTATION_SELECT_ID_CONTRAT: "ID_CONTRAT",
  CONSULTATION_SELECT_ID_BIEN: "ID_BIEN",
  CONSULTATION_SELECT_CIN: "CIN",
  CONSULTATION_SELECT_REF_REG: "REF_REGLEMENT",

  CLIENTS_SELECT_QUICK_SEARCH: "QUICK_SEARCH",
  CLIENTS_SELECT_CIN: "CIN",
  CLIENTS_SELECT_PASSPORT: "PASSPORT",
  CLIENTS_SELECT_LAST_NAME: "LAST_NAME",

  APPARTEMENT: "APPARTEMENT",
  MAGASIN: "MAGASIN",
  LOT: "LOT",
  VILLA: "VILLA",
  EQUIPEMENT: "EQUIPEMENT",

  STATUT_SIGNE_NOTAIRE: "SIGNE NOTAIRE",
  STATUT_UNIQUE: "UNIQUE",
  STATUT_DISPONIBLE: "DISPONIBLE",
  STATUT_BLOQUE: "BLOQUE",
  STATUT_NON_VENDABLE: "Non Vendable",

  // specialities: {
  //   get [(this as any).constants.ROLE_ADMIN](){
  //     return {
  //       color: "black",
  //       text: "Administrateur"
  //     }
  //   },
  //   get [(this as any).constants.ROLE_COMMERCIAL](){
  //     return {
  //       color: "darkgreen",
  //       text: "Commercial"
  //     }
  //   },
  //   get [(this as any).constants.ROLE_RESPONSABLE](){
  //     return {
  //       color: "saddlebrown",
  //       text: "Responsable"
  //     }
  //   },
  //   get [(this as any).constants.ROLE_DG](){
  //     return {
  //       color: "dimgrey",
  //       text: "Directeur Général"
  //     }
  //   },
  //   get [(this as any).constants.ROLE_DC](){
  //     return {
  //       color: "saddlebrown",
  //       text: "Directeur Commercial"
  //     }
  //   },
  //   get [(this as any).constants.ROLE_DAF](){
  //     return {
  //       color: "rebeccapurple",
  //       text: "Directeur Administratif et Financier"
  //     }
  //   },
  // },

  ROLE_ADMIN: 1,
  ROLE_COMMERCIAL: 2,
  ROLE_COMPTABLE: 3,
  ROLE_DG: 4,
  ROLE_DC: 5,
  ROLE_DAF: 6,
  ROLE_RESPONSABLE: 7,
  ROLE_PROMOTEUR: 8,
  ROLE_INTERMEDIAIRE: 9,

  DOC_CONTRAT_SIGNE: "CONTRAT_SIGNE",
  DOC_ACTE_DESISTEMENT: "ACTE_DESISTEMENT",
  DOC_ANNULATION_TRANSFERT: "ANNULATION_TRANSFERT",
  DOC_ACCORD_CREDIT: "ACCORD_CREDIT",
  DOC_MOTIF_CHEQUE_IMPAYE: "MOTIF_CHEQUE_IMPAYE",
  DOC_RECU_RESERVATION_SIGNE: "RECU_RESERVATION_SIGNE",
  DOC_FICHE_VENTE_VALIDEE: "FICHE_VENTE_VALIDEE",
  DOC_OTHER: "OTHER",

  STATUT_ENC_DEFAULT: "RECEPTION",
  STATUT_ENC_PTF: "PTF",
  STATUT_ENC_EI: "EI",
  STATUT_ENC_ENCAISSE: "ENCAISSE",
  STATUT_ENC_IMPAYE: "IMPAYE",
  STATUT_ENC_REPRESENTE: "REPRESENTE",
  STATUT_ENC_RECUPERE: "RECUPERE",
  STATUT_ENC_A_RECUPERER: "A_RECUPERER",
  STATUT_ENC_A_NE_PAS_VERSER_NR: "A_NE_PAS_VERSER_NR",
  STATUT_ENC_A_NE_PAS_VERSER_R: "A_NE_PAS_VERSER_R",
  STATUT_ENC_A_NE_PAS_VERSER____________: "A_NE_PAS_VERSER",
  STATUT_ENC_OLD_VERSEMENT: "VERSEMENT",
  STATUT_ENC_NOTAIRE: "NOTAIRE",

  // NOTIFICATION_TYPE_INFO: {
  //   value: 1,
  //   label: "Information"
  // },
  // NOTIFICATION_TYPE_WARNING: {
  //   value: 2,
  //   label: "Avertissement"
  // },
  // NOTIFICATION_TYPE_ANNOUNCEMENT: {
  //   value: 3,
  //   label: "Annonce"
  // },
  // NOTIFICATION_TYPE_REMINDER: {
  //   value: 4,
  //   label: "Rappel"
  // },
  // NOTIFICATION_TYPE_CONGRATULATION: {
  //   value: 5,
  //   label: "Félicitation"
  // },
  NOTIFICATION_TYPES: [
    {
      code: 1,
      label: "Information",
      color: "cornflowerblue",
      icon: faInfoCircle
    },
    {
      code: 2,
      label: "Erreur de saisie",
      color: "red",
      icon: faExclamation
    },
    {
      code: 3,
      label: "Avertissement",
      color: "darkred",
      icon: faExclamationTriangle
    },
    {
      code: 4,
      label: "Annonce",
      color: "purple",
      icon: faBullhorn
    },
    {
      code: 5,
      label: "Rappel",
      color: "orange",
      icon: faStopwatch
    },
    {
      code: 6,
      label: "Félicitation",
      color: "green",
      icon: faThumbsUp
    },
  ],

  MONTHS_ABBRV: ["janv.", "févr.", "mars", "avril", "mai", "juin", "juill.", "août", "sept.", "oct.", "nov.", "déc."],
  MONTHS_ABBRV0: {
    1: "janv.",
    2: "févr.",
    3: "mars",
    4: "avril",
    5: "mai",
    6: "juin",
    7: "juill.",
    8: "août",
    9: "sept.",
    10: "oct.",
    11: "nov.",
    12: "déc."
  },

  MODE_REGL_CHEQUE: "CHEQUE",
  MODE_REGL_VIREMENT: "VIREMENT",
  MODE_REGL_VERSEMENT: "VERSEMENT",
  MODE_REGL_COMPENSATION: "COMPENSATION",

  TYPE_ECHE_ACOMPTE: "Acompte réservation",
  TYPE_ECHE_RECOUVREMENT: "Recouvrement",
  TYPE_ECHE_LIVRAISON: "Reliquat livraison",

  COMMISSION_VU_ID: "VU",
  COMMISSION_VA_ID: "VA",
  COMMISSION_VP_ID: "VP",
  COMMISSION_L_ID: "L",
  COMMISSION_SC_ID: "SC",
  COMMISSION_CN_ID: "CN",
  COMMISSION_E_ID: "E",
  COMMISSION_ER_ID: "ER",
  COMMISSION_EEI_ID: "EEI",
  COMMISSION_EEncaisse_ID: "EEncaisse",
  COMMISSION_EImpaye_ID: "EImpaye",
  COMMISSION_ENotaire_ID: "ENotaire",
  COMMISSION_EInactif_ID: "EInactif",
  COMMISSION_EImpayeInactif_ID: "EImpayeInactif",

  formulaIdColors: ["cornflowerblue", "brown", "blueviolet", "blue", "chartreuse", "darkgoldenrod", "cyan", "darkcyan", "darkmagenta", "green"],

  CH_NULL: "CH_NULL",
  CH_NOT_NULL: "CH_NOT_NULL",
  CH_GRAYED: "CH_GRAYED",
  CH_NOT_GRAYED: "CH_NOT_GRAYED",
  CH_REJECTED: "CH_REJECTED",
  CH_NOT_REJECTED: "CH_NOT_REJECTED",
  CH_VALIDATED: "CH_VALIDATED",
  CH_NOT_VALIDATED: "CH_NOT_VALIDATED",
  CH_PAID: "CH_PAID",
  CH_NOT_PAID: "CH_NOT_PAID",

  encNrColor: "#FBAF59",
  encRColor: "#fffec8",
  encImpColor: "orangered",
  encNotValidColor: "#cc66ff",
}

// c["specialities"] = {
//   get [c.STATUT_SIGNE_NOTAIRE](){
//     return {
//       test: c.STATUT_SIGNE_NOTAIRE,
//       color: "dimgrey",
//       text: "Directeur Général"
//     }
//   },
// };